import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IBOMLisParameterResponse } from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { setBomLisParameters } from "@/app_redux/reducers/slices/auth/inventory_slice";

AxiosCurlirize(axios, () => {});

export const useBOMLisParametersAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(async () => {
    dispatch(
      setLoading({
        key: "isInventoryServiceListLoadingInProgess",
        status: true,
      }),
    );
    const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
    await axios
      .get(`${INVENTORY_MODULE?.BOM_LIS_PARAMETERS?.baseURL}`, {
        headers: {
          Authorization: `${accessToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((res: AxiosResponse<IBOMLisParameterResponse>) => {
        dispatch(setBomLisParameters({ data: res.data?.parameters ?? [] }));
        dispatch(
          setLoading({
            key: "isInventoryServiceListLoadingInProgess",
            status: false,
          }),
        );
      })
      .catch((e: AxiosError) => {
        dispatch(setBomLisParameters({ data: [] }));
        dispatch(
          setLoading({
            key: "isInventoryServiceListLoadingInProgess",
            status: false,
          }),
        );
        sendCurl(e.config["curlCommand"]);
      });
  }, [dispatch, configuration]);

  return execute;
};
